

import {FETCH_BUTTON_CLICKED} from '../action/type.js'
import {BANK_LIST} from '../action/type.js'

const reducer = (state = null, action) => { 
    switch (action.type) {
        case "Increment":
           return action.payload;          
            break;
        case "Decrement":
            return  action.payload;
            break;
        case FETCH_BUTTON_CLICKED:
            return  action.payload;
            break;
        case BANK_LIST:
            return  action.payload;
            break;
        default:
            break;
    }
    return state;
}
export default reducer;